import { Component, OnInit } from '@angular/core';
import { JsonService } from '../_services/json.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../dialog/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingService } from '../_services/loading.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-pdv-detail',
  templateUrl: './pdv-detail.component.html',
  styleUrl: './pdv-detail.component.scss'
})
export class PdvDetailComponent implements OnInit {
  public jsonPaises: Array<any> = [];
  public allRegioes: Array<any> = [];
  public listaRegiao: Array<any> = [];
  public uid: string = '';
  public pathSelected: string = '';
  public loading: boolean = false;
  public formPdv: FormGroup;
  public isCreateMode: boolean = false;

  constructor(
    private jsonService: JsonService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private loadingService: LoadingService,
    private fb: FormBuilder,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.formPdv = this.createPdvForm();
    this.uid = this.route.snapshot.paramMap.get('uid') || '';
    this.isCreateMode = !this.uid || this.uid === 'novo';
    this.pathSelected = this.isCreateMode ? this.translate.instant('Adicionar PDV') : '';
    this.loadCountries();
    this.loadRegions();

    if (!this.isCreateMode) {
      this.getDadosPdv(this.uid);
    }
  }

  private createPdvForm(data?: any): FormGroup {
    return this.fb.group({
      Id: data?.id || '',
      CountryId: data?.countryId || '',
      RegionId: data?.regionId || '',
      CdgCiudad: data?.cdgCiudad || '',
      Ciudad: data?.ciudad || '',
      CdgFarmac: data?.cdg_farmac || '',
      Name: data?.name || ''
    });
  }

  getDadosPdv(uid: string) {
    this.loadingService.show();
    this.jsonService.getPdvDetail(uid).subscribe(
      resp => {
        this.formPdv = this.createPdvForm(resp);
        this.pathSelected = resp.name;
        this.onCountryChange(false);
        this.loadingService.hide();
      },
      erro => {
        console.error(erro);
        this.loadingService.hide();
      }
    );
  }

  loadCountries() {
    this.jsonService.listCountry().subscribe(
      resp => {
        this.jsonPaises = resp;
      },
      erro => {
        console.error(erro);
      }
    );
  }

  loadRegions() {
    this.jsonService.getRegiao().subscribe(
      resp => {
        this.allRegioes = resp;
        this.onCountryChange(false);
      },
      erro => {
        console.error(erro);
      }
    );
  }

  onCountryChange(clearRegion: boolean = true): void {
    const countryId = this.formPdv.value.CountryId;
    this.listaRegiao = this.allRegioes
      .filter(regiao => regiao.countryId === countryId)
      .sort((a, b) => a.name.localeCompare(b.name));

    if (clearRegion) {
      this.formPdv.patchValue({ RegionId: '', CdgCiudad: '', Ciudad: '' });
    }
  }

  onRegionChange(): void {
    const regionId = this.formPdv.value.RegionId;
    const region = this.allRegioes.find(r => r.id === regionId);
    this.formPdv.patchValue({
      CdgCiudad: region ? region.regionCode : '',
      Ciudad: region ? region.name : ''
    });
  }

  savePdv() {
    if (this.isCreateMode) {
      this.createPdv();
    } else {
      this.updatePdv();
    }
  }

  createPdv() {
    if (!this.validatePdvForm()) {
      return;
    }

    this.loadingService.show();
    const formData = this.buildPdvFormData(false);

    this.jsonService.createPdv(formData).subscribe(
      () => {
        let title = this.translate.instant('Êxito') + '!';
        let message = this.translate.instant('PDV criado com sucesso!');
        this.dialogService.abrirDialog('aviso', title, message);
        this.loadingService.hide();
        this.router.navigate(['/pdv-lista']);
      },
      erro => {
        console.error(erro);
        this.loadingService.hide();
        let title = this.translate.instant('Atenção') + '!';
        let message = erro?.error || this.translate.instant('Erro ao criar PDV.');
        this.dialogService.abrirDialog('erro', title, message);
      }
    );
  }

  updatePdv() {
    if (!this.validatePdvForm()) {
      return;
    }

    this.loadingService.show();
    const formData = this.buildPdvFormData(true);

    this.jsonService.updatePdv(formData).subscribe(
      () => {
        let title = this.translate.instant('Êxito') + '!';
        let message = this.translate.instant('PDV atualizado com sucesso!');
        this.dialogService.abrirDialog('aviso', title, message);
        this.loadingService.hide();
        this.router.navigate(['/pdv-lista']);
      },
      erro => {
        console.error(erro);
        this.loadingService.hide();
        let title = this.translate.instant('Atenção') + '!';
        let message = erro?.error || this.translate.instant('Erro ao atualizar PDV.');
        this.dialogService.abrirDialog('erro', title, message);
      }
    );
  }

  private validatePdvForm(): boolean {
    const valuesToValidate = { ...this.formPdv.value };
    if (this.isCreateMode) {
      delete valuesToValidate.Id;
    }

    const allFieldsFilled = Object.values(valuesToValidate).every(val => val !== null && val !== '');

    if (!allFieldsFilled) {
      let title = this.translate.instant('Atenção') + '!';
      let message = this.translate.instant('Preencha todos os campos obrigatórios!');
      this.dialogService.abrirDialog('aviso', title, message);
      return false;
    }

    return true;
  }

  private buildPdvFormData(includeId: boolean): FormData {
    const formData = new FormData();
    Object.entries(this.formPdv.value).forEach(([key, value]) => {
      if ((includeId || key !== 'Id') && value !== null && value !== undefined) {
        formData.append(key, value.toString());
      }
    });

    return formData;
  }
}
